
































import { defineComponent, computed, watch, reactive, getCurrentInstance } from '@vue/composition-api';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
interface Props {
  show: boolean;
  group: SMH.ColleborationSpaceInfoData;
}
export default defineComponent({
  name: 'RenameGroup',
  props: {
    show: {
      required: true,
      type: Boolean,
      default: true,
    },
    group: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { groupNameMaxLength } = ConstantConfig;
    const rules = {
      name: [
        {
          required: true,
          message: i18n_t('请输入团队名称'),
        },
        {
          validator: (val: string) => !val.includes('/'),
          message: i18n_t('名称不支持字符“/”'),
        },
      ],
    };
    const formData = reactive<{
      name: string;
    }>({
      name: '',
    });
    const disabledSubmit = computed(() => !formData.name);
    const methods = {
      initData() {
        formData.name = props.group.name;
      },
      async onSubmit() {
        const validate = await (context.refs.form as any).validate();
        if (typeof validate === 'boolean' && validate) {
          const params = {
            groupId: props.group.id,
            name: formData.name,
          };
          try {
            await smh.userAPI.updateCollaborationSpace(params);
            tips.success(i18n_t('重命名成功'));
            methods.onClose();
            context.emit('success');
          } catch (error: MsgError) {
            tips.error(error);
          }
        }
      },
      onClose() {
        innerShow.value = false;
      },
    };
    watch(innerShow, val => {
      if (val) {
        methods.initData();
      }
    });
    return {
      innerShow,
      rules,
      disabledSubmit,
      formData,
      groupNameMaxLength,
      ...methods,
    };
  },
});
